import React from 'react';
import { CheckIcon } from 'lucide-react';
import { solutionPoints } from '../data/content';
export function Solution() {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-171" data-mp="1ek2p7swds9x4">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-172" data-mp="10tpi1srbcz8u">
        <h2 className="mx-auto max-w-4xl text-center text-[2rem] font-extrabold leading-[1.1] tracking-tight text-slate-900 md:text-5xl" data-id="element-173" data-mp="10r39pqwlmfpk">
          Todo lo que necesitás para practicar Anatomía, organizado en un solo sistema
        </h2>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-x-10 gap-y-5 md:grid-cols-2" data-id="element-174" data-mp="vumd08bc2t0v">
          {solutionPoints.map(point => {
          const [lead, ...rest] = point.split(':');
          return <li key={point} className="flex items-start gap-3" data-id="element-175" data-mp="msmufbko7gvt">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-900 text-white" data-id="element-176" data-mp="2c8ctyfnjxbrx">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="2h7pfmx2oscsx" />
                </span>
                <span className="text-slate-900" data-id="element-178" data-mp="708lc72r99x5">
                  <strong className="font-bold" data-id="element-179" data-mp="6yxlujgceobu">{lead}:</strong>
                  <span className="text-slate-600" data-id="element-180" data-mp="2y3vzkjcazgb">{rest.join(':')}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}